import { render, staticRenderFns } from "./selectsearch.vue?vue&type=template&id=dca45762"
import script from "./selectsearch.vue?vue&type=script&lang=js"
export * from "./selectsearch.vue?vue&type=script&lang=js"
import style0 from "./selectsearch.vue?vue&type=style&index=0&id=dca45762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports